/*
 * XYNE Redesign — Category grid notify-me modal
 *
 * Wires the "Notify me" coming-soon tiles on /pages/shop to a modal that
 * captures email + optional phone, tags the contact for the launch list
 * via Shopify's customer form, and shows a success stage in place.
 *
 * Liquid renders TWO form variants based on whether the customer is
 * logged in:
 *   - Anon: email + phone, creates a Shopify customer (their account
 *     becomes the preference center).
 *   - Logged-in: email is hidden (pre-filled with customer.email),
 *     just collects optional phone. Same tag payload, so Klaviyo
 *     automations see the contact as opted-in either way.
 *
 * Both forms post to the same /contact endpoint via AJAX. Klaviyo's
 * Shopify integration listens to customer creates / updates and applies
 * the contact[tags] value to the matching contact in Klaviyo, where
 * launch automations are configured.
 */
(function () {
  'use strict';

  function init() {
    var modal = document.querySelector('[data-rd-cats-modal]');
    if (!modal) return;

    var openTriggers = document.querySelectorAll('[data-rd-cats-notify]');
    var closeTriggers = modal.querySelectorAll('[data-rd-cats-modal-close]');
    var titleSlots = modal.querySelectorAll('[data-rd-cats-modal-title]');
    var formStage = modal.querySelector('[data-rd-cats-modal-stage="form"]');
    var successStage = modal.querySelector('[data-rd-cats-modal-stage="success"]');
    var form = modal.querySelector('form');
    var lastFocus = null;

    function open(triggerBtn) {
      lastFocus = document.activeElement;

      // Update the modal title with whichever tile was clicked
      var tileTitle = triggerBtn ? triggerBtn.getAttribute('data-tile-title') : '';
      if (tileTitle) {
        titleSlots.forEach(function (slot) { slot.textContent = tileTitle; });
      }

      // Reset to form stage on each open
      if (formStage) formStage.hidden = false;
      if (successStage) successStage.hidden = true;

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        document.body.classList.add('rd-cats-notify-open');
      });

      setTimeout(function () {
        var firstInput = form && form.querySelector('input[type="email"], input[type="tel"]');
        if (firstInput) firstInput.focus();
      }, 320);
    }

    function close() {
      document.body.classList.remove('rd-cats-notify-open');
      modal.setAttribute('aria-hidden', 'true');
      setTimeout(function () { modal.hidden = true; }, 320);
      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      }
    }

    function showSuccess() {
      if (formStage) formStage.hidden = true;
      if (successStage) successStage.hidden = false;
      // Move focus into success so the close button is reachable
      var successClose = successStage && successStage.querySelector('[data-rd-cats-modal-close]');
      if (successClose) successClose.focus();
    }

    // ---------- Open / close handlers ----------
    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open(btn);
      });
    });

    closeTriggers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('rd-cats-notify-open')) {
        close();
      }
    });

    // ---------- AJAX form submit ----------
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!('fetch' in window) || !('FormData' in window)) {
          // Native submit will reload the page; that's a fine fallback.
          return;
        }

        e.preventDefault();
        var submitBtn = form.querySelector('.rd-cats-notify__submit');
        var labelEl = submitBtn && submitBtn.querySelector('.rd-cats-notify__submit-label');
        var originalLabel = labelEl ? labelEl.textContent : '';

        if (submitBtn) submitBtn.disabled = true;
        if (labelEl) labelEl.textContent = 'Adding…';

        var data = new FormData(form);

        fetch(form.action || '/contact#contact_form', {
          method: 'POST',
          body: data,
          headers: { 'Accept': 'text/html' }
        })
          .then(function () {
            // Shopify's customer form returns the originating page on both
            // success and "already on list" — treat any non-network response
            // as success for UX. Klaviyo dedupes contacts at the platform
            // level so resubmits are safe.
            showSuccess();
          })
          .catch(function () {
            if (submitBtn) submitBtn.disabled = false;
            if (labelEl) labelEl.textContent = originalLabel;
            var errEl = form.querySelector('.rd-cats-notify__error');
            if (!errEl) {
              errEl = document.createElement('p');
              errEl.className = 'rd-cats-notify__error';
              errEl.setAttribute('role', 'alert');
              form.appendChild(errEl);
            }
            errEl.textContent = 'Couldn’t reach the server — try again in a moment.';
          });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
